import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VOverlay,{staticClass:"overlay",attrs:{"opacity":"0.85"},model:{value:(this.loading),callback:function ($$v) {_vm.$set(this, "loading", $$v)},expression:"this.loading"}},[_c(VProgressCircular,{staticClass:"spinner",attrs:{"indeterminate":"","size":"70"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }